export default {
  errors: state => state.errors,
  params: state => state.params,
  category: state => state.params.category,
  allSearchResults: state => state.searchResults,
  isLoading: state => state.isLoading,
  success: state => state.success,
  showSearchResults: state => state.showSearchResults
}
